import {Box} from 'platform/foundation';

import {useRef} from 'react';

import {DocumentPreviewPage} from '../types/DocumentPreviewPage';
import {UseDocumentPreviewReturnType} from '../types/UseDocumentPreviewReturnType';
import {ZoomRef} from '../types/ZoomRef';
import {ImagePreviewZoomActions} from './ImagePreviewZoomActions';
import {Zoom} from './Zoom';
import {ZoomImage} from './ZoomImage';

interface ImagePreviewWithZoomProps {
  documentPage: DocumentPreviewPage;
  documentPreview: UseDocumentPreviewReturnType;
}

export function ImagePreviewWithZoom(props: ImagePreviewWithZoomProps) {
  const zoomRef = useRef<ZoomRef>(null);

  const onZoomOut = () => {
    if (!zoomRef.current) {
      return;
    }
    zoomRef.current.zoomOut();
  };

  const onZoomIn = () => {
    if (!zoomRef.current) {
      return;
    }
    zoomRef.current.zoomIn();
  };

  return (
    <Box position="relative" width="100%" height="100%">
      <Zoom
        ref={zoomRef}
        renderPage={(ref) => (
          <ZoomImage ref={ref} data-testid="page-detail" page={props.documentPage} />
        )}
        data-testid="page-detail"
      />

      <ImagePreviewZoomActions onZoomOut={onZoomOut} onZoomIn={onZoomIn} />
    </Box>
  );
}
